<div class="space-y-2 px-6 py-3 border-2 rounded-md" [ngClass]="hasError() ? 'border-red-500' : 'border-gray-900/10'">
    <div class="text-base font-semibold my-0.5 grid-cols-2">
        {{ title() }}
        @if (optional()) {
            <span class="italic text-xs font-light">neobavezno</span>
        }
    </div>

    @if (!isKng()) {
        <div class="flex gap-2" [ngClass]="isPerksPreview() ? 'items-center' : ''">
            @if (isPerksPreview()) {
                <div
                    draggable="true"
                    (click)="uploadBrowse()"
                    (dragenter)="$event.preventDefault(); hovering = true"
                    (dragover)="$event.preventDefault()"
                    (dragleave)="$event.preventDefault(); hovering = false"
                    (drop)="uploadDrop($event)"
                    class="relative h-48 w-48"
                    [ngClass]="{ 'cursor-pointer': !value().fileName && !value().url }"
                >
                    <div
                        class="flex justify-center items-center overflow-hidden rounded-full border-2 border-dashed h-full w-full"
                        [ngClass]="{
                            'border-valamarblueprimary': value().fileName || value().url || hovering,
                            'border-black': !(value().fileName || value().url || hovering),
                        }"
                    >
                        @if (value().base64 || value().url) {
                            <img
                                [alt]="value().fileName"
                                [src]="value().base64 || value().url"
                                class="w-full h-full object-cover"
                            />
                        }
                        @if (!value().base64 && !value().url) {
                            <div class="flex flex-col items-center justify-center px-3">
                                <mat-icon class="pointer-events-none text-valamarblueprimary text-4xl">folder_open</mat-icon>
                                <span class="text-xs text-center pointer-events-none">Povuci ili klikni za odabir datoteke</span>
                            </div>
                        }
                    </div>
                    @if (value().base64 || value().url) {
                        <button
                            type="button"
                            (click)="removeSelectedFile($event)"
                            class="valben-icon-button valben-icon-button--danger valben-icon-button--compact absolute top-1 right-1"
                            aria-label="Ukloni datoteku">
                            <mat-icon>close</mat-icon>
                        </button>
                    }
                </div>
            }

            @if (!isPerksPreview()) {
                <div
                    draggable="true"
                    (click)="uploadBrowse()"
                    (dragenter)="$event.preventDefault(); hovering = true"
                    (dragover)="$event.preventDefault()"
                    (dragleave)="$event.preventDefault(); hovering = false"
                    (drop)="uploadDrop($event)"
                    class="flex justify-center items-center max-w-xl border-2 rounded-md border-dashed p-4 min-h-32 w-1/2 min-w-0"
                    [ngClass]="{
                        'border-valamarblueprimary': value().fileName || hovering,
                        'border-black': !(value().fileName || hovering),
                        'cursor-pointer': !value().fileName,
                    }"
                >
                    @if (value().fileName) {
                        <div class="relative flex flex-col gap-1 items-center justify-center w-full px-2">
                            <ng-container [ngSwitch]="fileTypeCode()">
                                <img
                                    *ngSwitchCase="1"
                                    [alt]="value().fileName"
                                    [src]="value().base64"
                                    class="max-w-full max-h-20 object-contain shrink-0"
                                />

                                <video *ngSwitchCase="2" class="max-w-full max-h-20 object-contain shrink-0">
                                    <source [src]="value().base64" [type]="value().contentType" />
                                    Browser ne podržava ovaj video format
                                </video>

                                <mat-icon *ngSwitchDefault class="text-4xl">description</mat-icon>
                            </ng-container>

                            <p class="text-sm text-center truncate max-w-full shrink-0">{{ value().fileName }}</p>
                            <button
                                type="button"
                                (click)="removeSelectedFile($event)"
                                class="valben-icon-button valben-icon-button--danger valben-icon-button--compact absolute top-0 right-0"
                                aria-label="Ukloni datoteku">
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>
                    }

                    @if (!value().fileName && !value().url) {
                        <div class="flex flex-col items-center justify-center gap-1 px-2">
                            <mat-icon class="pointer-events-none text-valamarblueprimary text-4xl">folder_open</mat-icon>
                            <span class="text-sm text-center pointer-events-none">Povuci ili klikni za odabir datoteke</span>
                        </div>
                    }

                    @if (value().url) {
                        <p class="text-xs text-center">
                            Zadan je url datoteke, obriši url za omogućen upload
                        </p>
                    }
                </div>
            }

            <div class="w-px self-stretch bg-valamardarkgray rounded-full shrink-0"></div>

            <div class="flex items-center gap-2 w-1/3">
                <input
                    class="grow h-10 border focus:outline-none rounded-md text-md p-2 grid-cols-1"
                    type="text"
                    [ngModel]="urlDraft"
                    (ngModelChange)="urlDraft = $event"
                    (blur)="commitUrl()"
                    placeholder="URL datoteke"
                    [disabled]="!!value().fileName"
                />
                @if (value().url) {
                    <button
                        type="button"
                        (mousedown)="$event.preventDefault(); clearUrl()"
                        class="valben-icon-button valben-icon-button--danger valben-icon-button--compact"
                        aria-label="Očisti URL">
                        <mat-icon>close</mat-icon>
                    </button>
                }
            </div>
        </div>
    }

    @if (isKng() && !preview()) {
        <div class="flex gap-2">
            <div
                draggable="true"
                (click)="uploadBrowse()"
                (dragenter)="$event.preventDefault(); hovering = true"
                (dragover)="$event.preventDefault()"
                (dragleave)="$event.preventDefault(); hovering = false"
                (drop)="uploadDrop($event)"
                class="flex justify-center items-center max-w-xl border-2 rounded-md border-dashed p-4 min-h-32 w-1/2 min-w-0"
                [ngClass]="{
                    'border-valamarblueprimary': value().fileName || hovering,
                    'border-black': !(value().fileName || hovering),
                    'cursor-pointer': !value().fileName,
                }"
            >
                @if (value().fileName || value().url) {
                    <div class="relative flex flex-col gap-1 items-center justify-center w-full px-2">
                        @if (value().fileName !== '') {
                            <p class="text-sm text-center truncate max-w-full shrink-0">{{ value().fileName }}</p>
                        }
                        @if (value().fileName === '') {
                            <p class="text-sm text-center truncate max-w-full shrink-0">{{ value().url | name }}</p>
                        }
                        <button
                            type="button"
                            (click)="removeSelectedFile($event)"
                            class="valben-icon-button valben-icon-button--danger valben-icon-button--compact absolute top-0 right-0"
                            aria-label="Ukloni datoteku">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                }

                @if (!value().fileName && !value().url) {
                    <div class="flex flex-col items-center justify-center gap-1 px-2">
                        <mat-icon class="pointer-events-none text-valamarblueprimary text-4xl">folder_open</mat-icon>
                        <span class="text-sm text-center pointer-events-none">Povuci ili klikni za odabir datoteke</span>
                    </div>
                }
            </div>

            @if (previewFile()) {
                <div
                    (click)="openPreview()"
                    class="flex justify-center items-center max-w-xl border-2 rounded-md border-dashed p-4 h-32 w-1/2 min-w-0 cursor-pointer"
                    [ngClass]="{
                        'border-valamarblueprimary': value().url || value().base64,
                        'border-black': !(value().url || value().base64),
                    }"
                >
                    @if (value().url || value().base64) {
                        <div class="flex flex-col items-center justify-center gap-1">
                            <mat-icon class="pointer-events-none text-valamarblueprimary text-4xl">visibility</mat-icon>
                            <span class="text-sm text-center pointer-events-none">Pregledaj datoteku</span>
                        </div>
                    }
                    @if (!value().url && !value().base64) {
                        <div class="flex flex-col items-center justify-center gap-1">
                            <mat-icon class="pointer-events-none text-valamardarkgray text-4xl">visibility_off</mat-icon>
                            <span class="text-sm text-center pointer-events-none">Nema datoteke za pregled</span>
                        </div>
                    }
                </div>
            }

            <div class="w-px self-stretch bg-valamardarkgray rounded-full shrink-0"></div>
        </div>
    }

    @if (isKng() && preview()) {
        <div class="flex gap-2">
            <div
                (click)="openPreview()"
                class="flex justify-center items-center max-w-xl border-2 rounded-md border-dashed p-4 h-28 w-1/2 min-w-0 cursor-pointer"
                [ngClass]="{
                    'border-valamarblueprimary': value().url || value().base64,
                    'border-black': !(value().url || value().base64),
                }"
            >
                @if (value().url || value().base64) {
                    <div class="flex flex-col items-center justify-center gap-1">
                        <mat-icon class="valben-file-preview-icon pointer-events-none text-valamarblueprimary text-3xl">visibility</mat-icon>
                        <span class="text-sm text-center pointer-events-none">Pregledaj datoteku</span>
                    </div>
                }
                @if (!value().url && !value().base64) {
                    <div class="flex flex-col items-center justify-center gap-1">
                        <mat-icon class="valben-file-preview-icon pointer-events-none text-valamardarkgray text-3xl">visibility_off</mat-icon>
                        <span class="text-sm text-center pointer-events-none">Nema datoteke za pregled</span>
                    </div>
                }
            </div>

            <div
                (click)="downloadFile()"
                class="flex justify-center items-center max-w-xl border-2 rounded-md border-dashed p-4 h-28 w-1/2 min-w-0"
                [ngClass]="{
                    'border-valamarblueprimary cursor-pointer': value().url || value().base64,
                    'border-black': !(value().url || value().base64),
                }"
            >
                @if (value().url || value().base64) {
                    <div class="flex flex-col items-center justify-center gap-1">
                        <mat-icon class="pointer-events-none text-valamarblueprimary text-3xl">download</mat-icon>
                        <span class="text-sm text-center pointer-events-none">Preuzmi datoteku</span>
                    </div>
                }
                @if (!value().url && !value().base64) {
                    <div class="flex flex-col items-center justify-center gap-1">
                        <mat-icon class="pointer-events-none text-valamardarkgray text-3xl">download</mat-icon>
                        <span class="text-sm text-center pointer-events-none">Nema datoteke za preuzimanje</span>
                    </div>
                }
            </div>
        </div>
    }
</div>

<input #browseFile type="file" hidden [accept]="fileType()" (change)="uploadBrowseChange($event)" />
